<template>
  <div class="pega-comment area">
    <job-preview-comment-thread
      v-for="(value,i) in comments"
      :key="`${value.id}-${i}`"
      :comment-thread="value"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import JobPreviewCommentThread from '@/components/molecules/JobPreviewCommentThread'
export default {
  components: {
    JobPreviewCommentThread
  },
  props: {
    comments: {
      type: Array,
      required: true
    }
  }
}
</script>
